/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Form_LabelInputs */

const en_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Options`)
};

const fr_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options d'exportation`)
};

const de_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportoptionen`)
};

const it_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di esportazione`)
};

const ru_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры экспорта`)
};

const es_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de exportación`)
};

const zh_cn2_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口选项`)
};

const ja_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートオプション`)
};

const hi_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात विकल्प`)
};

const pt_pt2_dialogue_list_export_form_label = /** @type {(inputs: Dialogue_List_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de exportação`)
};

/**
* | output |
* | --- |
* | "Export Options" |
*
* @param {Dialogue_List_Export_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_form_label = /** @type {((inputs?: Dialogue_List_Export_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_form_label(inputs)
	if (locale === "de") return de_dialogue_list_export_form_label(inputs)
	if (locale === "it") return it_dialogue_list_export_form_label(inputs)
	if (locale === "ru") return ru_dialogue_list_export_form_label(inputs)
	if (locale === "es") return es_dialogue_list_export_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_form_label(inputs)
	if (locale === "ja") return ja_dialogue_list_export_form_label(inputs)
	if (locale === "hi") return hi_dialogue_list_export_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_form_label(inputs)
	return en_dialogue_list_export_form_label(inputs)
});